var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('label',{staticClass:"question-label",attrs:{"for":_vm.elementId}},[_vm._v(_vm._s(_vm.question))]),_c('div',[_c('date-picker',{attrs:{"id":_vm.elementId,"value":_vm.dateValue,"format":"DD-MMM-YYYY"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }